import { render, staticRenderFns } from "./log-list.vue?vue&type=template&id=124b9dec"
import script from "./log-list.vue?vue&type=script&lang=js"
export * from "./log-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports